import styled, { css } from "styled-components";
import { borderRadius, boxShadow, color, onHover, typeStyle, units } from "@m/alchemy-theme";
import { lighten } from "polished";
export const DragHandle = styled.div `
  color: ${(props) => lighten(0.1, color("typeMeta")(props))};
  cursor: move;
  cursor: ${({ isDragging }) => (isDragging ? "grabbing" : "grab")};
  position: relative;
  flex-grow: 1;
  max-width: ${units(2)};
  transition: all 200ms ease;
  left: 0;
  opacity: ${({ isDragging }) => (isDragging ? 0.21 : 0)};
  ${({ isTouch }) => isTouch && `opacity:1;`}

  & > svg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    margin-top: ${units(0.25)};
  }
`;
export const ReorderableList = styled.ol `
  position: relative;
`;
export const DragWrapper = styled.div `
  padding: ${units(0.5)} 0 ${units(0.5)};
  transition:
    box-shadow 100ms ease,
    transform 100ms ease,
    background-color 200ms ease;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  width: 100%;

  user-select: none;

  ${({ isSelected, isDragging }) => isSelected &&
    !isDragging &&
    css `
      transform: scale(1.03);
      outline: none;
      border-bottom: 1px solid ${color("highlight")};
      background-color: ${color("hint")};
      z-index: 1;
      box-shadow: ${boxShadow(8)};
    `}

  ${onHover(css `
    ${DragHandle} {
      color: ${({ isDragging, theme }) => isDragging
    ? lighten(0.1, color("typeMeta")({
        theme,
        palette: "interactiveConstructive"
    }))
    : color("contrast")};
    }
  `)}

  ${({ isBeautifulDragging, theme }) => isBeautifulDragging &&
    css `
      cursor: move;
      cursor: grab;
      background-color: ${color("hint")({ theme, palette: "interactiveConstructive" })};
    `}
`;
export const DragListItem = styled.li `
  position: relative;
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  width: 100%;
  margin-bottom: ${({ hasChildren }) => (hasChildren ? "0" : units(0.5))};

  ol {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    flex-grow: 1;
    width: 100%;
    padding: 0 0 0 ${units(2)};
  }

  ${onHover(css `
      background-color: ${({ theme, activeColorScheme }) => activeColorScheme === "alchemyDark" || activeColorScheme === "alchemyBrand"
    ? color("hint")
    : color("hint")({ theme, palette: "interactiveConstructive" })};

      ${DragWrapper} {
        cursor: move;
        cursor: grab;
        background-color: transparent;
      }
      ${DragHandle} {
        opacity: 1;
        left: ${units(0.5)};
      }
    `, { includeKeyboardFocus: true, includeFocusWithin: true })}
`;
export const DragContent = styled.div `
  color: ${color("typeBody")};
  flex-grow: 1;
  opacity: ${({ isDragging, disabled }) => (disabled ? 0.55 : isDragging ? 0.21 : 1)};
`;
export const DropTarget = styled.div `
  height: 48%;
  min-height: ${units(2)};
  ${({ hasChildren }) => hasChildren && `max-height:${units(5)};`}
  display: block;
  z-index: 1;
  width: 100%;
  position: absolute;
  overflow: hidden;
  left: 0px;
  ${({ isTopAligned }) => (isTopAligned ? `top:0` : `bottom:${units(0.5)};`)}
  transition: all 100ms ease;
  ${({ isTopAligned }) => (isTopAligned ? `border-top: 3px solid;` : `border-bottom: 3px solid;`)}
  border-color: ${({ isOver }) => (isOver ? color("base") : "transparent")};
`;
export const DragLayerWrapper = styled.div `
  position: fixed;
  pointer-events: none;
  z-index: 5;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;
export const PreviewContent = styled.div `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: ${color("container")};
  max-width: 250px;
  cursor: move !important; /* fallback: no support or images disabled */
  cursor: -webkit-grabbing !important; /* Chrome 1-21, Safari 4+ */
  cursor: -moz-grabbing !important; /* Firefox 1.5-26 */
  cursor: grabbing !important; /* W3C standards syntax, should come least */

  padding: ${units(0.5)} ${units(1)};
  opacity: 0.89;
  ${typeStyle("base")};

  transform-origin: left top;
  box-shadow: ${boxShadow(4)};
`;
export const NestedDropZoneWrapper = styled.div.attrs({
    palette: "interactiveConstructive"
}) `
  background: ${color("container")};
  border: 1px dotted ${color("base")};
  border-radius: ${borderRadius()};
  min-height: ${units(2)};
  margin: ${units(0.5)} 0 0 ${units(2)};
  width: 100%;
`;
